/**
 * A hour tag's colour as a dot — the tag's own colour (Tag Rules › Hours),
 * else the primary colour; dashed when the hour cannot be judged.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { FC } from 'react';

import { cn } from '@/lib/utils';

interface Props {
  color?: string | null;
  unknown?: boolean;
  className?: string;
}

export const TagDot: FC<Props> = ({ color, unknown, className }) => (
  <span
    aria-hidden
    className={cn(
      'inline-block h-2.5 w-2.5 shrink-0 rounded-full',
      unknown ? 'border border-dashed border-muted-foreground/60' : !color && 'bg-primary',
      className,
    )}
    style={!unknown && color ? { background: color } : undefined}
  />
);
